import { readOnly } from '@ember/object/computed';
import Service, { inject as service } from '@ember/service';
import { PAYOUT__SH_PAYMENT_INCLUDES } from "../../../../../constants/routes/admin/accounting/payout";
import { EMBER_ROUTE_NAMES } from "../../../../../constants/routes";

export default Service.extend({
  /**
   * Register Services
   */
  applicationStateManager: service('state-managers/application'),
  session: service(),
  shPaymentCommandService : service('commands/sh-payment-commands'),
  state: service('states/routes/admin/accounting/payout'),
  store: service(),

  currentUser: readOnly('session.currentUser'),

  /**
   * Handle updating state after a payment transaction has been created/updated
   *
   * @param {ShPayment} shPayment
   * @param {ShPaymentTransaction} shPaymentTransaction
   */
  handlePaymentTransactionSaved(shPayment, shPaymentTransaction) {
    shPayment.get('shPaymentTransactions').addObject(shPaymentTransaction);
    shPayment.set('paidAt', new Date());
  },

  /**
   * @return {*|Ember.RSVP.Promise}
   */
  loadNextPaymentsPage() {
    const pagination = this.get('state.currentPagination');
    this.navigateToPaymentsPage(pagination.get('currentPage') + 1);
  },

  /**
   * @return {*|Ember.RSVP.Promise}
   */
  loadPreviousPaymentsPage() {
    const pagination = this.get('state.currentPagination');
    this.navigateToPaymentsPage(pagination.get('currentPage') - 1);
  },

  /**
   * Load the sh payments
   *
   * @param {Number} page
   * @param {Number} count
   * @param {Object} filter
   * @return {Ember.RSVP.Promise}
   */
  loadShPayments(page, count, filter) {
    this.set('state.currentFilter', filter);
    this.set('state.isLoadingPayments', true);

    return this.get('shPaymentCommandService').loadShPayments(
      page,
      count,
      filter,
      PAYOUT__SH_PAYMENT_INCLUDES
    ).then(response => {
      this.set('state.shPayments', response.shPayments);
      this.set('state.currentPagination', response.pagination);
    }).catch(() => {
      // gobble gobble
    }).finally(() => this.set('state.isLoadingPayments', false));
  },

  /**
   * Navigate to a specific page of payments
   *
   * @param {Number} page
   */
  navigateToPaymentsPage(page) {
    const queryParams = this.get('state.queryParams');

    queryParams['page'] = page;

    this.get('applicationStateManager').setNextRoute(
      EMBER_ROUTE_NAMES.ADMIN__ACCOUNTING__PAYOUT,
      {
        queryParams: queryParams
      }
    );
  },

  /**
   * Re-initialize the stateManager
   */
  initStateManager() {
    this.get('state').init();
  }
});
